module.exports = __webpack_public_path__ + "static/media/arrow-left-white.66cb5846.svg";